import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "utils/metaPixel";

const PixelPageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const consent = localStorage.getItem("pixelConsent");

    if (consent === "accepted") {
      trackPageView();
    }
  }, [location]);

  return null;
};

export default PixelPageTracker;
